import generateRootMeta from './rootMeta'
import AvatarPlaceholder from '#images/avatar-placeholder.png'

const generateUserProfileMeta = ({
	origin = 'https://atomiclore.io',
	path,
	user,
}: {
	origin?: string
	path: string
	user?: { id: string; username: string; userAvatar: string; wallets: string[] }
}) => {
	if (user) {
		try {
			const title = user.username
				? `${user.username} profile | Atomic Lore`
				: import.meta.env.VITE_APP_NAME
					? import.meta.env.VITE_APP_NAME
					: 'Atomic Lore'
			const description = user
				? `All the cryptographically signed stories by ${user.username}, beautifully displayed`
				: import.meta.env.VITE_APP_DESCRIPTION
					? import.meta.env.VITE_APP_DESCRIPTION
					: 'A tool to explore NFT history, by Atomic Form'
			const image = user.userAvatar ? user.userAvatar : AvatarPlaceholder

			return [
				{
					title: title,
				},
				{
					property: 'og:title',
					content: title,
				},
				{ property: 'og:url', content: origin + path },
				{
					name: 'description',
					content: description,
				},
				{
					property: 'og:description',
					content: description,
				},
				{ property: 'og:site_name', content: 'atomiclore.io' },
				// IMAGE
				{ name: 'image', content: image },
				{
					property: 'og:image',
					content: image,
				},
				{ property: 'og:image:width', content: '1200px' },
				{ property: 'og:image:height', content: '630px' },
				// TWITTER / SLACK
				{
					name: 'twitter:image',
					content: image,
				},
				{ name: 'twitter:card', content: 'summary_large_image' },
				{ name: 'twitter:site', content: '@atomicform' },
				{ name: 'twitter:creator', content: '@atomicform' },
				{
					name: 'twitter:description',
					content: description,
				},
				{
					name: 'twitter:title',
					content: title,
				},
			]
		} catch (e) {
			console.error('ERROR GENERATING USER PROFILE META', e)
			const metaPayload = generateRootMeta({ path, origin })
			return metaPayload
		}
	} else {
		const metaPayload = generateRootMeta({ path, origin })
		return metaPayload
	}
}

export default generateUserProfileMeta
